import React, { useEffect, useState } from "react";
import { PortWidget } from "@projectstorm/react-diagrams-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleDown,
  faCircleLeft,
  faCircleRight,
} from "@fortawesome/free-regular-svg-icons";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import ErrorBoundary from "../../Builder/Components/ErrorBoundary";
import ComponentInfoPopup from "../components/ComponentInfoPopup";
import { proxyAPI } from "../../proxyAPI";

const { baseUrl: baseURL } = JSON.parse(
  document.querySelector("#app").dataset.page
).props;

export default function ComponentNodeWidget({ node, engine }) {
  const [dragOver, setDragOver] = useState(false);
  const [componentData, setComponentData] = useState();

  const getData = async () => {
    const data = await proxyAPI({
      prefix: "logic/workflows/api",
      url: `/project/${node.options.componentID}`,
      setLoading: () => null,
    });
    if (data) {
      setComponentData(data);
    }
  };

  useEffect(() => {
    if (node.options.componentID) {
      getData();
    } else {
      setComponentData(node.options.component);
    }
  }, [node]);

  return (
    componentData && (
      <ErrorBoundary>
        <div
          tabIndex={-1}
          style={{ width: 300, height: 300 }}
          className="position-relative p-3"
        >
          {node.getPort("In") && (
            <div className="position-absolute top-0 start-50 translate-middle">
              <PortWidget engine={engine} port={node.getPort("In")}>
                <FontAwesomeIcon icon={faCircleDown} size="2x" />
              </PortWidget>
            </div>
          )}
          <div
            className={`position-absolute top-50 start-0 translate-middle rounded-circle ${
              dragOver === "Left" ? "bg-primary" : ""
            }`}
            onDragOver={(e) => {
              e.preventDefault();
              setDragOver("Left");
            }}
            onDragLeave={() => setDragOver(false)}
            onDrop={(e) => {
              setDragOver(false);
              engine.handleDrop(e, node.getPort("Left"));
              e.stopPropagation();
            }}
          >
            <PortWidget engine={engine} port={node.getPort("Left")}>
              <FontAwesomeIcon icon={faCircleLeft} size="2x" />
            </PortWidget>
          </div>
          <div
            className={`position-absolute top-50 start-100 translate-middle rounded-circle ${
              dragOver === "Right" ? "bg-primary" : ""
            }`}
            onDragOver={(e) => {
              e.preventDefault();
              setDragOver("Right");
            }}
            onDragLeave={() => setDragOver(false)}
            onDrop={(e) => {
              setDragOver(false);
              engine.handleDrop(e, node.getPort("Right"));
              e.stopPropagation();
            }}
          >
            <PortWidget engine={engine} port={node.getPort("Right")}>
              <FontAwesomeIcon icon={faCircleRight} size="2x" />
            </PortWidget>
          </div>
          <div
            className={`position-absolute top-100 start-50 translate-middle rounded-circle ${
              dragOver === "Out" ? "bg-primary" : ""
            }`}
            onDragOver={(e) => {
              e.preventDefault();
              setDragOver("Out");
            }}
            onDragLeave={() => setDragOver(false)}
            onDrop={(e) => {
              setDragOver(false);
              engine.handleDrop(e, node.getPort("Out"));
              e.stopPropagation();
            }}
          >
            <PortWidget engine={engine} port={node.getPort("Out")}>
              <FontAwesomeIcon icon={faCircleDown} size="2x" />
            </PortWidget>
          </div>
          <div
            className="position-relative border border-3 rounded-3 h-100 border-purple bg-purple-gradient p-3"
            style={{
              boxShadow: node.options.selected ? "0px 0px 8px 0px purple" : "",
            }}
            onDragOver={(e) => {
              e.preventDefault();
              setDragOver("Out");
            }}
            onDragLeave={() => setDragOver(false)}
            onDrop={(e) => {
              setDragOver(false);
              engine.handleDrop(e, node.getPort("Out"));
              e.stopPropagation();
            }}
          >
            <div className="d-flex justify-content-end m-2">
              <ComponentInfoPopup component={componentData} />
              <button
                type="button"
                className="btn btn-sm btn-link p-0 link-danger"
                onClick={() => {
                  node.remove(true);
                  engine.repaintCanvas();
                }}
                aria-label="Delete"
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </div>
            <h3 className="text-center">{componentData.Label}</h3>
            {componentData.InputArguments?.length > 0 && (
              <div className="bg-white rounded-3">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item p-1">
                    <span className="fw-bold">Needs Input Arguments:</span>
                  </li>
                  {componentData.InputArguments?.map((arg) => (
                    <li key={arg.UUID} className="list-group-item p-1">
                      {arg.Label}  [{arg.Format}]
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </ErrorBoundary>
    )
  );
}
